module.exports = __webpack_public_path__ + "static/media/industry_hover3.ced63bf1.svg";